// extracted by mini-css-extract-plugin
export default {"optionContainer":"styles__optionContainer___pR28F","optionTitle":"styles__optionTitle___Y0T2m","optionDescription":"styles__optionDescription___1C-TH"};